import TIM from 'tim-js-sdk';
import TIMUploadPlugin from 'tim-upload-plugin';
import store from '@/store/index';
import * as $http from '@/axios';

const options = {
  SDKAppID: process.env.VUE_APP_IM_SDK_ID
};
const tim = TIM.create(options); // SDK 实例通常用 tim 表示
// 设置 SDK 日志输出级别，详细分级请参见 setLogLevel https://web.sdk.qcloud.com/im/doc/zh-cn/SDK.html#setLogLevel 接口的说明</a>
tim.setLogLevel(4); // 普通级别，日志量较多，接入时建议使用
// tim.setLogLevel(1); // release 级别，SDK 输出关键信息，生产环境时建议使用

// 注册腾讯云即时通信 IM 上传插件
tim.registerPlugin({ 'tim-upload-plugin': TIMUploadPlugin });

// var springFestivalMessageList = [];

const groupID = process.env.VUE_APP_IM_GROUP_ID;
const messageObj = {
  springFestivalMessageList: [] //新春活动弹幕
};

// 更新用户资料
const updateUserProfile = () => {
  const userInfo = store.state.user.userInfo;
  if (!userInfo) return;

  tim.updateMyProfile({
    nick: userInfo.nickname,
    avatar: userInfo.avatarUrl,
    allowType: TIM.TYPES.ALLOW_TYPE_ALLOW_ANY
  });
};

// 获取加入的群组列表
const getGroupList = async () => {
  try {
    const imResponse = await tim.getGroupList();
    if (imResponse.data.groupList) {
      return imResponse.data.groupList;
    }
  } catch (error) {
    return Promise.reject(false);
  }
};

const joinGroup = async () => {
  return tim.joinGroup({ groupID: groupID });
};

// 登录im
const imLogin = async userInfo => {
  try {
    const { data } = await $http.get('/im/auth/sign');
    const { data: responseData } = await tim.login({
      userID: userInfo.uuid,
      userSig: data
    });
    return responseData;
  } catch (error) {
    return Promise.reject(error);
  }
};

// 发送消息
const sendMessage = payload => {
  //创建自定义消息。
  let message = tim.createCustomMessage({
    to: groupID, //群组id
    conversationType: TIM.TYPES.CONV_GROUP, //类型为群组会话
    payload: {
      data: payload.data,
      description: payload.description
    }
    // payload: {
    //   data: JSON.stringify({
    //     isAnonymity: true, //是否匿名
    //     isTop: true //是否置顶
    //   }),
    //   description: JSON.stringify({
    //     nickname: this.isAnonymity ? '神秘老闆' : this.userInfo.nickname, //显示的用户姓名，匿名时为神秘老板
    //     playerName: this.selectedPlayer.nickname, //玩家姓名
    //     message: this.message, //发送的消息
    //     userName: this.userInfo.nickname // 用户的真实姓名
    //   })
    // }
  });
  return tim.sendMessage(message);
};

const addSpringFestivalLocalMessage = message => {
  messageObj.springFestivalMessageList.push(message);
};
const initSpringFestivalLocalMessage = () => {
  messageObj.springFestivalMessageList = [];
};

const onMessageReceived = event => {
  try {
    console.log('onMessageReceived', event);
    const messageList = event.data.filter(item => {
      return (
        item.conversationID.search(groupID) != -1 && item.from !== '@TIM#SYSTEM'
      );
    });
    if (messageList && messageList.length) {
      messageObj.springFestivalMessageList = [
        ...messageObj.springFestivalMessageList,
        ...messageList
      ];
    }
    console.log(messageObj.springFestivalMessageList);
  } catch (error) {
    console.log(error);
  }
  // messageList.forEach(message => {
  //   if (message.type === TIM.TYPES.MSG_TEXT) {
  //     // 文本消息 - https://web.sdk.qcloud.com/im/doc/zh-cn/Message.html#.TextPayload
  //   } else if (message.type === TIM.TYPES.MSG_IMAGE) {
  //     // 图片消息 - https://web.sdk.qcloud.com/im/doc/zh-cn/Message.html#.ImagePayload
  //   } else if (message.type === TIM.TYPES.MSG_SOUND) {
  //     // 音频消息 - https://web.sdk.qcloud.com/im/doc/zh-cn/Message.html#.AudioPayload
  //   } else if (message.type === TIM.TYPES.MSG_VIDEO) {
  //     // 视频消息 - https://web.sdk.qcloud.com/im/doc/zh-cn/Message.html#.VideoPayload
  //   } else if (message.type === TIM.TYPES.MSG_FILE) {
  //     // 文件消息 - https://web.sdk.qcloud.com/im/doc/zh-cn/Message.html#.FilePayload
  //   } else if (message.type === TIM.TYPES.MSG_CUSTOM) {
  //     // 自定义消息 - https://web.sdk.qcloud.com/im/doc/zh-cn/Message.html#.CustomPayload
  //   } else if (message.type === TIM.TYPES.MSG_MERGER) {
  //     // 合并消息 - https://web.sdk.qcloud.com/im/doc/zh-cn/Message.html#.MergerPayload
  //   } else if (message.type === TIM.TYPES.MSG_LOCATION) {
  //     // 地理位置消息 - https://web.sdk.qcloud.com/im/doc/zh-cn/Message.html#.LocationPayload
  //   } else if (message.type === TIM.TYPES.MSG_GRP_TIP) {
  //     // 群提示消息 - https://web.sdk.qcloud.com/im/doc/zh-cn/Message.html#.GroupTipPayload
  //   } else if (message.type === TIM.TYPES.MSG_GRP_SYS_NOTICE) {
  //     // 群系统通知 - https://web.sdk.qcloud.com/im/doc/zh-cn/Message.html#.GroupSystemNoticePayload
  //   }
  //   if (message.conversationType === TIM.TYPES.CONV_GROUP) {
  //   }
  // });
  // if (messageList && messageList.length) {
  //   springFestivalMessageList = [...springFestivalMessageList, ...messageList];
  // }
};

let IM_SDK_READY;

const IM_READY = new Promise(res => {
  IM_SDK_READY = function() {
    res();
  };
});

// sdk已加载
const sdkReady = () => {
  IM_SDK_READY();
  updateUserProfile();
};
tim.on(TIM.EVENT.SDK_READY, sdkReady);
tim.on(TIM.EVENT.MESSAGE_RECEIVED, onMessageReceived);

export default {
  tim,
  IM_READY,
  imLogin,
  getGroupList,
  joinGroup,
  sendMessage,
  updateUserProfile,
  TYPES: TIM.TYPES,
  messageObj,
  addSpringFestivalLocalMessage,
  initSpringFestivalLocalMessage
};
